import { FieldKey, t } from '../i18n';
import { isQuoted } from '../models/common';

import { validateReservedWordsAndPhrases } from './reserved-words';

const validateName = (value: string, isAdmin: boolean, field: FieldKey = 'field-name'): string => {
    const normalized = value.toLowerCase();
    if (normalized === '') {
        return '';
    }
    if (isQuoted(normalized)) {
        return t('quoted', { field: t(field) });
    }
    return validateReservedWordsAndPhrases(normalized, isAdmin, field);
};

export default validateName;
